import { render, staticRenderFns } from "./LoadingRE.vue?vue&type=template&id=8d5697e4&scoped=true&"
import script from "./LoadingRE.vue?vue&type=script&lang=js&"
export * from "./LoadingRE.vue?vue&type=script&lang=js&"
import style0 from "./LoadingRE.vue?vue&type=style&index=0&id=8d5697e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5697e4",
  null
  
)

export default component.exports